export default function Script({
  children,
  index,
  className = '',
  isScripts,
  currentScript,
  handleClickScript,
}: {
  children: React.ReactNode
  index: number
  className?: string
  isScripts: boolean
  currentScript: number
  handleClickScript: (_scriptNumber: number, _event: React.MouseEvent) => void
}) {
  return (
    <button
      style={{
        cursor: 'pointer',
        padding: '.5rem',
      }}
      className={`js-script ${isScripts && currentScript === index ? 'active' : ''} ${className}`}
      onClick={(event) => handleClickScript(index, event)}
      tabIndex={-1}
    >
      {children}
    </button>
  )
}
